import { useState, useEffect } from 'react';

const slides = [
  {
    title: 'Premium Sojat Henna Powder Manufacturer',
    description: 'Fresh crop henna leaves processed into fine mesh powder for hair and mehndi use.',
    cta: 'Get Quote',
    ctaAction: 'contact',
    image: 'https://readdy.ai/api/search-image?query=Premium%20natural%20green%20henna%20powder%20in%20elegant%20bowl%20with%20fresh%20henna%20leaves%20arranged%20artistically%20on%20clean%20white%20marble%20surface%2C%20professional%20product%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20high%20quality%20sojat%20mehendi%20powder%2C%20fine%20texture%20visible%2C%20botanical%20aesthetic%2C%20pure%20and%20organic%20feel&width=1920&height=1080&seq=hero1&orientation=landscape'
  },
  {
    title: 'Bulk Supply for Distributors & Resellers',
    description: 'Factory-direct henna powder at competitive wholesale prices.',
    cta: 'Contact Us',
    ctaAction: 'contact',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20henna%20powder%20manufacturing%20facility%20with%20sealed%20moisture%20proof%20pouches%20and%20bulk%20packaging%20bags%20stacked%20neatly%2C%20clean%20white%20factory%20environment%2C%20professional%20wholesale%20business%20setup%2C%20organized%20storage%20area%2C%20quality%20control%20standards%20visible%2C%20modern%20packaging%20equipment%2C%20hygienic%20production%20space&width=1920&height=1080&seq=hero2&orientation=landscape'
  },
  {
    title: 'Natural, Pure & Finely Filtered Henna Powder',
    description: 'Smooth texture, natural green color, perfect for hair care and mehndi designs.',
    cta: 'WhatsApp Now',
    ctaAction: 'whatsapp',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mehndi%20design%20being%20applied%20on%20hands%20with%20natural%20henna%20cone%2C%20intricate%20traditional%20patterns%2C%20smooth%20green%20henna%20paste%20texture%2C%20artistic%20mehendi%20application%2C%20cultural%20beauty%20ritual%2C%20elegant%20hand%20decoration%2C%20fine%20quality%20henna%20powder%20result%2C%20clean%20white%20background%2C%20professional%20beauty%20photography&width=1920&height=1080&seq=hero3&orientation=landscape'
  }
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleCTA = (action: string) => {
    if (action === 'whatsapp') {
      window.open('https://wa.me/919649408405', '_blank');
    } else {
      scrollToSection('contact');
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {/* Background Image */}
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          </div>

          {/* Content */}
          <div className="relative h-full flex items-center justify-center">
            <div className="container mx-auto px-4 lg:px-8">
              <div className="max-w-4xl mx-auto text-center text-white">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl lg:text-2xl mb-8 text-white/90">
                  {slide.description}
                </p>
                <button
                  onClick={() => handleCTA(slide.ctaAction)}
                  className="px-8 py-4 bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 text-base md:text-lg font-semibold whitespace-nowrap cursor-pointer shadow-lg"
                >
                  {slide.cta}
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
            }`}
          />
        ))}
      </div>

      {/* Scroll Down Indicator */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}